import type { Messages } from '../i18n.types'

/** German admin UI strings (ADR-043). */
export const de: Messages = {
  common: {
    breadcrumb: 'Brotkrümelnavigation',
    loading: 'Wird geladen',
    somethingWrong: 'Etwas ist schiefgelaufen',
    reference: 'Referenz: {id}',
    dismiss: 'Schließen',
    close: 'Schließen',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    delete: 'Löschen',
    remove: 'Entfernen',
    save: 'Speichern',
    saving: 'Wird gespeichert…',
    create: 'Erstellen',
    edit: 'Bearbeiten',
    search: 'Suche',
    type: 'Typ',
    status: 'Status',
    all: 'Alle',
    yes: 'Ja',
    no: 'Nein',
    untitled: 'Ohne Titel',
    previous: 'Zurück',
    next: 'Weiter',
    total: '{count} insgesamt',
    range: '{from}–{to} von {total}',
    selected: '{count} ausgewählt',
    selectItem: '{name} auswählen',
    name: 'Name',
    key: 'Schlüssel',
    description: 'Beschreibung',
    actions: 'Aktionen',
    updated: 'Geändert',
    created: 'Erstellt',
    version: 'Version',
    language: 'Sprache',
    languages: 'Sprachen',
    allLanguages: 'Alle Sprachen',
    refresh: 'Aktualisieren',
    back: 'Zurück',
    open: 'Öffnen',
    none: 'Keine',
    email: 'E-Mail',
    password: 'Passwort',
    displayName: 'Anzeigename',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    details: 'Details',
    filter: 'Filter',
    clear: 'Zurücksetzen',
    view: 'Ansehen',
  },
  list: {
    any: 'Beliebig',
    filters: 'Filter',
    results: '{count} Ergebnisse',
    resultOne: '1 Ergebnis',
    clear: 'Filter zurücksetzen',
    removeFilter: 'Filter entfernen: {name}',
    since: 'seit {day}',
    until: 'bis {day}',
    min: 'Min.',
    max: 'Max.',
    from: 'Von',
    to: 'Bis',
    range: '{first}–{last} von {total}',
    perPage: 'Pro Seite',
    pages: 'Seiten',
    noneMatch: 'Nichts passt zu den Filtern',
    noneMatchHelp: 'Ändern oder entfernen Sie die Filter, um mehr zu sehen.',
  },
  nav: {
    dashboard: 'Übersicht',
    content: 'Inhalte',
    media: 'Medien',
    contentTypes: 'Inhaltstypen',
    plugins: 'Plugins',
    users: 'Benutzer',
    roles: 'Rollen',
    audit: 'Protokoll',
    groupContent: 'Inhalte',
    groupBuild: 'Aufbau',
    groupAdmin: 'Verwaltung',
    mail: 'E-mail',
    backup: 'Datensicherung',
    website: 'Website',
  },
  crumbs: {
    content: 'Inhalte',
    newEntry: 'Neuer Eintrag',
    edit: 'Bearbeiten',
    contentTypes: 'Inhaltstypen',
    builder: 'Editor',
    media: 'Medien',
    users: 'Benutzer',
    roles: 'Rollen',
    plugins: 'Plugins',
    details: 'Details',
    extension: 'Erweiterung',
    audit: 'Protokoll',
    settings: 'Einstellungen',
    mail: 'E-mail',
    backup: 'Datensicherung',
    website: 'Website',
  },
  // English until translated.
  mail: {
    kicker: 'Settings',
    title: 'E-mail',
    lead: 'One SMTP account for every e-mail of the CMS and its plugins. A plugin can use its own SMTP account instead.',
    cmsTitle: 'CMS SMTP',
    effective: 'In use: {source}',
    sourceDatabase: 'the settings below',
    sourceEnvironment: 'the server configuration (SMTP_HOST {host})',
    sourceLog: 'none — e-mails are only written to the log',
    emptyHelp:
      'Leave the host empty to use the server configuration (SMTP_* variables).',
    host: 'SMTP host',
    port: 'Port',
    security: 'Encryption',
    securityNone: 'STARTTLS / none',
    securityTls: 'SSL/TLS',
    username: 'User name',
    password: 'Password',
    passwordKeep: 'Saved — leave empty to keep it',
    removePassword: 'Remove the saved password',
    fromName: 'Sender name',
    fromAddress: 'Sender address',
    fromOptional: 'Empty = the CMS sender',
    replyTo: 'Reply-to address (optional)',
    save: 'Save',
    saved: 'E-mail settings saved',
    testTitle: 'Send a test e-mail',
    testTo: 'Recipient',
    testSend: 'Send test',
    testSent: 'Test e-mail sent ({account})',
    testLogged:
      'No SMTP configured: the test e-mail was only written to the log',
    testFailed: 'Sending failed: {error}',
    pluginsTitle: 'Plugin SMTP accounts',
    pluginsLead:
      'Plugins send through the CMS SMTP unless they have their own account here.',
    plugin: 'Plugin',
    account: 'Account',
    usesCms: 'CMS SMTP',
    ownAccount: 'Own: {host}',
    ownDisabled: 'Own (off): {host}',
    configure: 'Own SMTP',
    edit: 'Edit',
    remove: 'Remove',
    removeConfirm:
      'Remove the SMTP account of {plugin}? It will send through the CMS SMTP again.',
    removed: 'Plugin SMTP account removed',
    pluginDialog: 'SMTP account for {plugin}',
    enabled: 'Use this account for the plugin’s e-mails',
    noPlugins: 'No plugins installed',
    deliveriesTitle: 'Recent e-mails',
    deliveriesEmpty: 'No e-mails sent yet',
    time: 'Time',
    source: 'Sender',
    to: 'To',
    subject: 'Subject',
    status: 'Status',
    statusSENT: 'Sent',
    statusFAILED: 'Failed',
    statusLOGGED: 'Logged only',
    accountplugin: 'plugin SMTP',
    accountcms: 'CMS SMTP',
    accountenvironment: 'server SMTP',
    accountlog: 'log',
    deliveriesSearch: 'Empfänger oder Betreff',
  },
  notifications: {
    title: 'Benachrichtigungen',
    unseen: '{count} neu',
    empty: 'Noch keine Benachrichtigungen.',
    markAllRead: 'Alle als gelesen markieren',
    dismiss: 'Verwerfen',
    soundOn: 'Benachrichtigungston einschalten',
    soundOff: 'Benachrichtigungston ausschalten',
    sources: {
      content: 'Inhalte',
      admin: 'Administrator',
      identity: 'Konten',
      media: 'Medien',
      plugins: 'Plugins',
    },
  },
  shell: {
    mainNavigation: 'Hauptnavigation',
    home: 'GX-CMS Startseite',
    noRole: 'Keine Rolle',
    lightTheme: 'Zum hellen Design wechseln',
    darkTheme: 'Zum dunklen Design wechseln',
    signOut: 'Abmelden',
    openNavigation: 'Navigation öffnen',
    filterMenu: 'Menü filtern',
    noMenuMatches: 'Keine passenden Seiten',
    expandAll: 'Alle Gruppen ausklappen',
    collapseAll: 'Alle Gruppen einklappen',
    resizeNavigation:
      'Navigationsbreite ändern: ziehen oder Pfeiltasten verwenden; Doppelklick oder Eingabe setzt zurück',
    collapseNavigation: 'Navigation auf Symbole verkleinern',
    expandNavigation: 'Navigation ausklappen',
    language: 'Sprache',
    accessDenied: 'Zugriff verweigert',
    accessDeniedText:
      'Sie haben keine Berechtigung für diese Seite. Bitten Sie eine Administratorin oder einen Administrator um Zugriff.',
    notFound: 'Seite nicht gefunden',
    notFoundText: 'Die gesuchte Seite existiert nicht.',
  },
  fields: {
    invalidJson: 'Ungültiges JSON',
    missingFile: 'Datei fehlt',
    addMedia: 'Medien hinzufügen',
    chooseMedia: 'Medien auswählen',
    missingEntry: 'Eintrag fehlt',
    unlink: 'Verknüpfung lösen',
    linkMore: 'Weitere verknüpfen',
    linkEntry: 'Eintrag verknüpfen',
    removeItem: 'Element entfernen',
    addItem: 'Element hinzufügen',
    linkEntries: 'Einträge verknüpfen',
    link: 'Verknüpfen',
    allAllowedTypes: 'Alle erlaubten Typen',
    noMatchingEntries: 'Keine passenden Einträge',
  },
  confirm: {
    stillInUse: 'Noch in Verwendung',
    andMore: '…und {count} weitere',
    deleteAnyway: 'Trotzdem löschen',
    typeToConfirm: 'Geben Sie {text} zur Bestätigung ein',
  },
  actor: {
    system: 'System',
    you: 'Sie',
    service: 'Dienst · {name}',
    plugin: 'Plugin · {name}',
    user: 'Benutzer {id}',
  },
  status: {
    PUBLISHED: 'veröffentlicht',
    ACTIVE: 'aktiv',
    ENABLED: 'aktiviert',
    READY: 'bereit',
    SUCCESS: 'erfolgreich',
    HEALTHY: 'in Ordnung',
    DRAFT: 'Entwurf',
    INSTALLED: 'installiert',
    IN_REVIEW: 'in Prüfung',
    SCHEDULED: 'geplant',
    PROCESSING: 'in Verarbeitung',
    UPLOADING: 'wird hochgeladen',
    INVITED: 'eingeladen',
    DISCOVERED: 'gefunden',
    ARCHIVED: 'archiviert',
    DISABLED: 'deaktiviert',
    DELETED: 'gelöscht',
    UNKNOWN: 'unbekannt',
    FAILED: 'fehlgeschlagen',
    FAILURE: 'Fehler',
    LOCKED: 'gesperrt',
    UNHEALTHY: 'gestört',
    PENDING: 'ausstehend',
  },
  auth: {
    hero: 'Inhalte, {em}',
    heroEm: 'unter Kontrolle.',
    sub: 'GX-CMS — strukturierte Inhalte, Versionen und Veröffentlichung für jeden Kanal.',
    welcome: 'Willkommen zurück',
    signIn: 'Anmelden',
    failed: 'Anmeldung fehlgeschlagen',
  },
  dashboard: {
    morning: 'Guten Morgen',
    afternoon: 'Guten Tag',
    evening: 'Guten Abend',
    lead: 'Was sich bei Ihren Inhalten tut.',
    newEntry: 'Neuer Eintrag',
    entries: 'Einträge',
    published: 'Veröffentlicht',
    drafts: 'Entwürfe',
    inReview: 'In Prüfung',
    scheduled: 'Geplant',
    recent: 'Zuletzt bearbeitet',
    viewAll: 'Alle anzeigen',
    noContent: 'Noch keine Inhalte',
    noContentText: 'Erstellen Sie Ihren ersten Eintrag, um ihn hier zu sehen.',
    awaitingReview: 'Wartet auf Prüfung',
    nothingReview: 'Nichts wartet auf Prüfung.',
    noScheduled: 'Keine geplanten Veröffentlichungen.',
    fromPlugins: 'Aus Ihren Plugins',
    byLanguage: 'Einträge nach Sprache',
  },
  entries: {
    drafts: 'Entwürfe',
    inReview: 'In Prüfung',
    scheduled: 'Geplant',
    published: 'Veröffentlicht',
    archived: 'Archiviert',
    liveIn: 'Live auf {language}',
    draftIn: 'Entwurf auf {language} (dort nicht veröffentlicht)',
    createEntry: 'Eintrag erstellen',
    noActiveTypes: 'Keine aktiven Inhaltstypen',
    noActiveTypesText:
      'Aktivieren Sie einen Inhaltstyp, bevor Sie Einträge erstellen.',
    deleteCount: {
      one: '{count} Eintrag löschen?',
      other: '{count} Einträge löschen?',
    },
    deleteText:
      'Die ausgewählten Einträge und ihr Versionsverlauf werden endgültig gelöscht. Veröffentlichte Seiten verschwinden von der Website. Dies kann nicht rückgängig gemacht werden.',
    stillReferenced: 'Einige Einträge werden noch referenziert',
    referencedText: {
      one: '{count} Eintrag ist mit anderen Einträgen verknüpft. Trotzdem löschen und diese Verknüpfungen entfernen?',
      other:
        '{count} Einträge sind mit anderen Einträgen verknüpft. Trotzdem löschen und diese Verknüpfungen entfernen?',
    },
    deleted: {
      one: '{count} Eintrag gelöscht',
      other: '{count} Einträge gelöscht',
    },
    deleteFailed: {
      one: '{count} Eintrag konnte nicht gelöscht werden.',
      other: '{count} Einträge konnten nicht gelöscht werden.',
    },
    allEntries: 'Alle Einträge',
    lead: 'Entwürfe, Prüfungen, geplante und veröffentlichte Inhalte aller Typen.',
    deleteN: '{count} löschen',
    searchPlaceholder: 'Titel oder Slug',
    contentType: 'Inhaltstyp',
    allTypes: 'Alle Typen',
    nothingMatches: 'Keine Treffer',
    noEntries: 'Noch keine Einträge',
    createAn: 'Eintrag erstellen',
    tryFilter: 'Versuchen Sie einen anderen Filter.',
    noEntriesText:
      'Von Ihnen erstellte Einträge erscheinen hier mit ihrem Workflow-Status.',
    selectAll: 'Alle löschbaren Einträge dieser Seite auswählen',
    title: 'Titel',
    live: 'Live',
    onlyOwn: 'Sie können nur eigene Einträge löschen',
    changes: 'Änderungen',
  },
  editor: {
    scheduleTitle: 'Veröffentlichung planen',
    schedule: 'Planen',
    scheduleText:
      'Die aktuelle Entwurfsversion wird zum gewählten Zeitpunkt automatisch veröffentlicht. Spätere Änderungen am Eintrag ändern nichts daran, was veröffentlicht wird.',
    publishAt: 'Veröffentlichen am',
    restoredPublished: 'Version {n} wiederhergestellt und veröffentlicht',
    restoredDraft: 'Version {n} als neuer Entwurf wiederhergestellt',
    versionN: 'Version {n}',
    restorePublish: 'Wiederherstellen & veröffentlichen',
    restoreDraft: 'Als Entwurf wiederherstellen',
    summary: 'Zusammenfassung',
    schema: 'Schema',
    restoreNote:
      'Beim Wiederherstellen entsteht eine neue Version aus diesem Stand. Der Verlauf wird nie umgeschrieben.',
    removeLanguageTitle: '{language} entfernen?',
    removeLanguageText:
      'Die Übersetzungen werden beim Speichern aus dem Eintrag entfernt, und nach der nächsten Veröffentlichung wird die Seite in dieser Sprache nicht mehr ausgeliefert. Frühere Versionen behalten sie.',
    discardTitle: 'Änderungen verwerfen?',
    discardText:
      'Sie haben ungespeicherte Änderungen. Ohne Speichern verlassen?',
    discard: 'Verwerfen',
    created: 'Eintrag erstellt',
    savedAs: 'Als Version {n} gespeichert',
    conflict:
      'Jemand anderes hat diesen Eintrag gespeichert. Laden Sie neu, um die Änderungen zu sehen.',
    chooseType: 'Wählen Sie einen Inhaltstyp, um einen Eintrag zu erstellen.',
    createDraft: 'Entwurf erstellen',
    saveDraft: 'Entwurf speichern',
    saved: 'Gespeichert',
    fixFields: 'Bitte korrigieren Sie die markierten Felder',
    actionFailed: 'Die Aktion konnte nicht ausgeführt werden',
    editingLanguage: 'Bearbeitungssprache',
    contentLanguage: 'Inhaltssprache',
    languagesHelp:
      'Die Sprachen, in denen dieser Eintrag existiert. Die Website zeigt ihn nur in diesen Sprachen; zum Veröffentlichen muss jedes Pflichtfeld in jeder davon ausgefüllt sein.',
    publishing: 'Veröffentlichung',
    liveChanges: 'Live · Änderungen ausstehend',
    draft: 'Entwurf',
    notPublished: 'Nicht veröffentlicht',
    publishedToast: 'Veröffentlicht',
    savePublish: 'Speichern & veröffentlichen',
    republish: 'Erneut veröffentlichen',
    publish: 'Veröffentlichen',
    submittedToast: 'Zur Prüfung eingereicht',
    submit: 'Zur Prüfung einreichen',
    returnedToast: 'Zurück in den Entwurf',
    returnToDraft: 'Zurück in den Entwurf',
    saveFirst: 'Zuerst speichern',
    scheduleCancelled: 'Planung aufgehoben',
    cancelSchedule: 'Planung aufheben',
    unpublishTitle: 'Veröffentlichung zurückziehen?',
    unpublishText:
      'Der Eintrag verschwindet sofort aus der Delivery-API. Der Entwurf bleibt erhalten.',
    unpublish: 'Zurückziehen',
    unpublishedToast: 'Veröffentlichung zurückgezogen',
    preview: 'Vorschau',
    archiveTitle: 'Eintrag archivieren?',
    archiveText:
      'Archivieren zieht die Veröffentlichung zurück und blendet den Eintrag in den Standardansichten aus.',
    archive: 'Archivieren',
    archivedToast: 'Archiviert',
    restoredToast: 'Wiederhergestellt',
    restore: 'Wiederherstellen',
    deleteTitle: 'Eintrag löschen?',
    deleteText:
      '„{title}“ und sein gesamter Versionsverlauf werden endgültig gelöscht.',
    deletePublic: 'Die öffentliche Seite verschwindet von der Website.',
    cannotUndo: 'Dies kann nicht rückgängig gemacht werden.',
    deleted: 'Eintrag gelöscht',
    slug: 'Slug',
    slugGenerated: 'Aus dem Titel erzeugt',
    slugHelp: 'Wird in URLs und der Delivery-API verwendet.',
    fromTitle: 'Aus Titel',
    changeNote: 'Änderungsnotiz',
    changeNotePlaceholder: 'Was hat sich geändert? (optional)',
    liveUrl: 'Öffentliche URL',
    noPublicPage:
      'Keine öffentliche Seite (Slug oder Kategorie fehlt, oder der Typ ist nicht öffentlich)',
    history: 'Verlauf',
    liveLower: 'live',
    draftSaved: 'Entwurf gespeichert',
    noHistory: 'Noch kein Verlauf.',
    scheduledFor: 'Geplant für {time}',
  },
  plugins: {
    plugin: 'Plugin',
    continue: 'Weiter',
    frameNoValues: 'Diese Erweiterung kann keine Feldwerte ändern.',
    frameAdminPaths: 'Es können nur Admin-Pfade geöffnet werden.',
    frameNoMedia: "Diesem Plugin wurde 'media.asset.read' nicht gewährt.",
    requestFailed: 'Anfrage fehlgeschlagen',
    isolated: 'Von einem Plugin in einem isolierten Rahmen dargestellt',
    extensionUnavailable: 'Erweiterung nicht verfügbar',
    extensionUnavailableText:
      'Diese Plugin-Seite ist nicht registriert, oder das Plugin ist deaktiviert.',
  },
  types: {
    titleField: 'Titel',
    createdToast: 'Inhaltstyp „{name}“ erstellt',
    newType: 'Neuer Inhaltstyp',
    namePlaceholder: 'Artikel',
    apiKey: 'API-Schlüssel',
    apiKeyHelp:
      'Wird in API-Pfaden verwendet, z. B. /api/v1/delivery/article. Kann später nicht geändert werden.',
    titleAdded: 'Für den Einstieg wird ein Pflichtfeld „Titel“ hinzugefügt.',
    kicker: 'Inhalte modellieren',
    lead: 'Legen Sie die Struktur Ihrer Inhalte fest. Einträge werden bei jedem Speichern und Veröffentlichen gegen diese Schemas geprüft.',
    none: 'Noch keine Inhaltstypen',
    createFirst: 'Ersten Typ erstellen',
    noneText:
      'Inhaltstypen beschreiben, wie ein Artikel, eine Seite oder ein Produkt aufgebaut ist.',
    fields: 'Felder',
    one: 'Inhaltstyp',
    searchPlaceholder: 'Name, API-Schlüssel oder Beschreibung',
  },
  fieldTypes: {
    TEXT: { label: 'Text', description: 'Kurzer Text wie Titel oder Namen' },
    RICH_TEXT: {
      label: 'Formatierter Text',
      description: 'Langer formatierter Text (Markdown)',
    },
    NUMBER: {
      label: 'Zahl',
      description: 'Ganz- oder Dezimalzahlen mit optionalen Grenzen',
    },
    BOOLEAN: { label: 'Ja/Nein', description: 'Ja-/Nein-Schalter' },
    DATE: { label: 'Datum', description: 'Kalenderdatum' },
    DATETIME: { label: 'Datum & Uhrzeit', description: 'Datum mit Uhrzeit' },
    JSON: { label: 'JSON', description: 'Beliebige strukturierte Daten' },
    MEDIA: {
      label: 'Medien',
      description: 'Bilder, Videos oder Dokumente aus der Mediathek',
    },
    RELATION: {
      label: 'Verknüpfung',
      description: 'Verweise auf andere Einträge',
    },
    ENUM: { label: 'Auswahl', description: 'Ein Wert aus einer festen Liste' },
    URL: { label: 'URL', description: 'Webadresse' },
  },
  builder: {
    required: 'Pflicht',
    localized: 'übersetzt',
    list: 'Liste',
    images: 'Bilder',
    video: 'Video',
    audio: 'Audio',
    defaultInvalid:
      'Der Standardwert muss gültiges JSON sein (z. B. "Text", 42, true oder ["a"]).',
    editField: 'Feld bearbeiten',
    addField: 'Feld hinzufügen',
    saveField: 'Feld speichern',
    locked:
      'Für diesen Typ gibt es Einträge. Schlüssel, Listen- und Übersetzungseinstellungen sind gesperrt; nur kompatible Typänderungen sind möglich.',
    label: 'Bezeichnung',
    keyHelp: 'Eigenschaftsname in den API-Daten.',
    requiredLabel: 'Pflichtfeld',
    localizedLabel: 'Übersetzt (ein Wert pro Sprache)',
    multiple: 'Mehrere Werte',
    helpText: 'Hilfetext',
    helpTextHelp: 'Wird unter dem Feld angezeigt.',
    validation: 'Validierung',
    minLength: 'Mindestlänge',
    maxLength: 'Höchstlänge',
    minimum: 'Minimum',
    maximum: 'Maximum',
    pattern: 'Muster (regulärer Ausdruck)',
    integer: 'Nur ganze Zahlen',
    minItems: 'Mindestanzahl',
    maxItems: 'Höchstanzahl',
    options: 'Optionen',
    optionsHelp: 'Eine Option pro Zeile.',
    allowedTypes: 'Erlaubte Inhaltstypen',
    anyType: 'Leer lassen, um jeden Typ zu erlauben.',
    allowedMedia: 'Erlaubte Medien',
    anyMedia: 'Leer lassen, um jeden Medientyp zu erlauben.',
    defaultValue: 'Standardwert (JSON)',
    defaultHelp: 'Gilt für neue Einträge. Beispiele: "Ohne Titel", 0, true.',
    settingsSaved: 'Einstellungen gespeichert',
    keysPermanent: 'Schlüssel sind dauerhaft.',
    titleField: 'Titelfeld',
    firstText: 'Erstes Textfeld',
    titleFieldHelp: 'Wird in Listen als Name des Eintrags angezeigt.',
    slugFrom: 'Slug erzeugen aus',
    noGenerate: 'Nicht erzeugen',
    slugRequired: 'Slug zum Veröffentlichen erforderlich',
    previewTemplate: 'Vorschau-URL-Vorlage',
    previewHelp:
      'Platzhalter: {slug}, {id}, {token}. Wird von der Aktion „Vorschau“ verwendet.',
    publicUrls: 'Öffentliche URLs',
    reserved:
      'Das Präfix {prefix} ist für {owner} reserviert. Eine Änderung verschiebt diese Seiten aus dem URL-Bereich des Plugins.',
    urlPrefix: 'URL-Präfix',
    urlPrefixHelp:
      'Erstes URL-Segment für diesen Typ. Muss eindeutig sein; Systemwörter und Sprachcodes sind reserviert.',
    categoryFrom: 'Kategoriesegment aus',
    noCategory: 'Kein Kategoriesegment',
    choice: 'Auswahl',
    linkedSlug: 'Slug des verknüpften Eintrags',
    categoryHelp:
      'Ein einzelnes Auswahlfeld oder eine Verknüpfung zu einem Kategorie-Eintrag.',
    publicPages: 'Einträge haben öffentliche Seiten',
    servedAt:
      'Seiten werden unter {path} ausgeliefert, in jeder Sprache, in der der Eintrag existiert. Einträge ohne Slug erhalten keine öffentliche Seite. Bei einer Präfixänderung funktionieren alte URLs über dauerhafte (308) Weiterleitungen.',
    servedAtCategory:
      'Seiten werden unter {path} ausgeliefert, in jeder Sprache, in der der Eintrag existiert. Einträge ohne Slug oder Kategorie erhalten keine öffentliche Seite. Bei Änderungen von Präfix oder Kategorie funktionieren alte URLs über dauerhafte (308) Weiterleitungen.',
    widgets: 'Feld-Widgets (Plugins)',
    defaultEditor: 'Standardeditor',
    saveSettings: 'Einstellungen speichern',
    fieldSaved: 'Feld gespeichert',
    viewEntries: 'Einträge ansehen',
    activated: 'Inhaltstyp aktiviert',
    activate: 'Aktivieren',
    archiveTitle: 'Inhaltstyp archivieren?',
    archiveText:
      'Es können keine neuen Einträge erstellt werden, und die Auslieferung für diesen Typ endet. Bestehende Einträge bleiben erhalten.',
    deleteTitle: 'Inhaltstyp löschen?',
    deleteWithEntries: {
      one: '„{name}“ und sein {count} Eintrag (jede Version und Sprache) werden endgültig gelöscht. Veröffentlichte Seiten verschwinden von der Website. Dies kann nicht rückgängig gemacht werden.',
      other:
        '„{name}“ und alle {count} Einträge (jede Version und Sprache) werden endgültig gelöscht. Veröffentlichte Seiten verschwinden von der Website. Dies kann nicht rückgängig gemacht werden.',
    },
    deleteEmpty:
      '„{name}“ wird endgültig gelöscht. Dies kann nicht rückgängig gemacht werden.',
    deleted: 'Inhaltstyp gelöscht',
    schemaVersion: 'Schemaversion {n}',
    noFields: 'Keine Felder',
    noFieldsText:
      'Fügen Sie Felder hinzu, um diesen Inhaltstyp zu beschreiben.',
    titleTag: 'TITEL',
    widget: 'Widget {name}',
    moveUp: 'Nach oben',
    moveDown: 'Nach unten',
    editX: '{name} bearbeiten',
    removeX: '{name} entfernen',
    removeFieldTitle: 'Feld entfernen?',
    removeFieldUsed:
      '„{name}“ verschwindet aus Editor und Auslieferung. Die Werte bleiben in älteren Versionen erhalten.',
    removeFieldEmpty: '„{name}“ wird entfernt.',
    fieldRemoved: 'Feld entfernt',
    namesTitle: 'Name auf der Website',
    namesHelp:
      'Wie dieser Typ in jeder Sprache heißt (Navigation, Bezeichnungen). Leer: der Name oben.',
  },
  media: {
    saved: 'Mediendetails gespeichert',
    details: 'Mediendetails',
    deleteTitle: 'Datei löschen?',
    deleteText:
      '„{name}“ wird aus dem Speicher entfernt und lädt nirgends mehr. Dies kann nicht rückgängig gemacht werden.',
    deleted: 'Datei gelöscht',
    file: 'Datei',
    size: 'Größe',
    uploaded: 'Hochgeladen',
    checksum: 'Prüfsumme',
    altText: 'Alternativtext',
    altHelp:
      'Beschreiben Sie das Bild für Screenreader. Für barrierefreie Inhalte erforderlich.',
    visibility: 'Sichtbarkeit',
    public: 'Öffentlich — feste URL, cachebar',
    private: 'Privat — nur kurzlebige signierte Links',
    linkCopied: 'Link kopiert',
    copyLink: 'Link kopieren',
    download: 'Herunterladen',
    kicker: 'Mediathek',
    lead: 'Bilder, Videos, Audio und Dokumente. Dateien liegen im Objektspeicher und werden anhand ihrer Signatur geprüft.',
    searchPlaceholder: 'Dateiname, Titel oder Alternativtext',
    documents: 'Dokumente',
    none: 'Noch keine Medien',
    noneText: 'Laden Sie Dateien hoch, um sie in Ihren Inhalten zu verwenden.',
    openX: '{name} öffnen',
    missingAlt: 'Alternativtext fehlt',
    noAlt: 'KEIN ALT',
    selectMedia: 'Medien auswählen',
    selectFile: 'Datei auswählen',
    useSelected: 'Auswahl verwenden',
    pickerSearch: 'Nach Dateiname oder Alternativtext suchen',
    searchMedia: 'Medien durchsuchen',
    noneFound: 'Keine Medien gefunden',
    uploadedX: '{name} hochgeladen',
    drop: '{strong} oder zum Auswählen klicken',
    dropStrong: 'Dateien hier ablegen',
    dropHelp:
      'Bilder, Videos, Audio und PDF. Der Dateityp wird beim Hochladen geprüft.',
  },
  pluginList: {
    kicker: 'Erweitern',
    lead: 'Plugins gelten als nicht vertrauenswürdig, bis eine Administratorin oder ein Administrator ihre Berechtigungen prüft, sie installiert und aktiviert. Sie laufen isoliert vom CMS-Kern.',
    invalid: '{count} Paket(e) mit Validierungsfehlern: {paths}',
    scanned: 'Registry durchsucht: {count} Paket(e)',
    scan: 'Registry durchsuchen',
    none: 'Keine Plugins gefunden',
    noneText:
      'Legen Sie Plugin-Pakete (mit einer cms-plugin.json) in das Registry-Verzeichnis und durchsuchen Sie die Registry.',
    capabilities: 'Berechtigungen',
    health: 'Zustand',
    update: 'Update: {version}',
    signed: 'Signiert',
    badSignature: 'Ungültige Signatur',
    packageMissing: 'Paket fehlt',
    granted: '{granted} / {requested} gewährt',
    noSettings: 'Dieses Plugin hat keine Einstellungen.',
    saveConfig: 'Konfiguration speichern',
    updates: 'Update verfügbar',
    searchPlaceholder: 'Name, Schlüssel oder Herausgeber',
  },
  pluginDetail: {
    features: 'Funktionen',
    featuresText:
      'Feature-Flags schalten Teile des Plugins für alle ein oder aus. Sie wirken nur, solange das Plugin aktiviert ist, und gewähren nie Berechtigungen.',
    installFirst:
      'Installieren Sie das Plugin, um seine Funktionen zu verwalten.',
    turnedOn: '{key} eingeschaltet',
    turnedOff: '{key} ausgeschaltet',
    inactive: 'inaktiv, solange das Plugin deaktiviert ist',
    changed: 'geändert {time}',
    installed: '{name} installiert',
    updatedTo: '{name} auf {version} aktualisiert',
    installX: '{name} installieren',
    updateX: '{name} aktualisieren',
    approveInstall: 'Genehmigen & installieren',
    approveUpdate: 'Genehmigen & aktualisieren',
    installFailed: 'Das Plugin konnte nicht installiert werden',
    unsigned:
      'Dieses Paket ist nicht von einem vertrauenswürdigen Herausgeber signiert. Installieren Sie nur Plugins, deren Quellcode Sie geprüft haben.',
    requests:
      '{name} {version} fordert die folgenden Berechtigungen an. Entfernen Sie alles, was Sie nicht gewähren möchten — das Plugin kann nur nutzen, was Sie genehmigen, und Sie können Berechtigungen jederzeit entziehen.',
    granted: 'Gewährt',
    migrationsWillRun:
      '{count} Migration(en) laufen in der isolierten Plugin-Laufzeit und werden im Protokoll festgehalten.',
    uninstallX: '{name} deinstallieren',
    uninstalled: 'Plugin deinstalliert',
    uninstall: 'Deinstallieren',
    uninstallText:
      'Alle Berechtigungen werden entzogen. Inhalte, die das Plugin über die CMS-API erstellt hat (z. B. Inhaltstypen), bleiben erhalten.',
    pluginData: 'Plugin-Daten',
    keepData:
      'Plugin-Daten und Konfiguration behalten (später neu installieren)',
    deleteData: 'Plugin-Daten und Konfiguration endgültig löschen',
    typeKey: 'Geben Sie {key} zur Bestätigung ein',
    disableX: '{name} deaktivieren',
    disabledToast: 'Plugin deaktiviert',
    disable: 'Deaktivieren',
    disableText:
      'Event-Abonnements, Jobs und Admin-Erweiterungen stoppen sofort. Plugin-Daten bleiben erhalten.',
    reason: 'Grund (optional)',
    incident: 'Sicherheitsvorfall — automatische Reaktivierung blockieren',
    install: 'Installieren',
    updateTo: 'Auf {version} aktualisieren',
    enabledToast: '{name} aktiviert',
    enable: 'Aktivieren',
    deleteTitle: 'Plugin-Eintrag löschen?',
    deleteGone:
      'Der Eintrag von „{name}“ (das Paket ist nicht mehr vorhanden) und alle aufbewahrten Plugin-Daten werden endgültig gelöscht.',
    deleteRegistry:
      'Der Eintrag von „{name}“ und alle aufbewahrten Plugin-Daten werden endgültig gelöscht. Das Paket liegt noch in der Registry und erscheint beim nächsten Durchsuchen wieder als gefunden.',
    deleted: 'Plugin gelöscht',
    lastError: 'Letzter Fehler',
    notCompatible: 'Nicht kompatibel',
    overview: 'Überblick',
    configuration: 'Konfiguration',
    migrations: 'Migrationen',
    package: 'Paket',
    installedLabel: 'Installiert',
    notInstalled: 'Nicht installiert',
    available: 'Verfügbar',
    publisher: 'Herausgeber',
    license: 'Lizenz',
    defaultLanguage: '{language} (Standard)',
    languagesHelp:
      'Die eigenen Seiten des Plugins verwenden die Admin-Sprache, wenn sie hier aufgeführt ist, sonst seine Standardsprache.',
    signature: 'Signatur',
    integrity: 'Integrität',
    homepage: 'Website',
    backendService: 'Backend-Dienst',
    bound: 'verbunden',
    notBound: 'nicht verbunden',
    permissionsAdded: 'Hinzugefügte Berechtigungen',
    defaultRoles: 'Standard: Administrator, {roles}',
    runtime: 'Laufzeit',
    lastCheck: 'Letzte Prüfung',
    backend: 'Backend',
    adminUi: 'Admin-Oberfläche',
    events: 'Events',
    jobs: 'Jobs',
    every: '{id} (alle {seconds} s)',
    dependencies: 'Abhängigkeiten',
    optional: 'optional',
    notInstalledLower: 'nicht installiert',
    missing: 'fehlt',
    grants: 'Gewährte Berechtigungen',
    grantsText:
      'Standardmäßig verweigert: Eine angeforderte Berechtigung wirkt erst nach der Gewährung. Ein Entzug wirkt innerhalb von Sekunden, auch für laufende Plugin-Prozesse.',
    grantedAt: 'Gewährt {time}',
    noLongerRequested: 'Nicht mehr angefordert',
    notGranted: 'Nicht gewährt',
    revokedToast: 'Berechtigung entzogen',
    grantedToast: 'Berechtigung gewährt',
    revoke: 'Entziehen',
    grant: 'Gewähren',
    configSaved: 'Konfiguration gespeichert',
    migrationsDone: 'Migrationen abgeschlossen',
    retry: 'Wiederholen',
    noMigrations: 'Keine Migrationen deklariert.',
    migration: 'Migration',
    applied: 'Angewendet',
  },
  users: {
    permissionsCount: '{count} Berechtigungen',
    created: 'Benutzer erstellt',
    invite: 'Benutzer einladen',
    createUser: 'Benutzer erstellen',
    initialPassword: 'Anfangspasswort',
    passwordHelp:
      'Mindestens 12 Zeichen mit drei von: Kleinbuchstaben, Großbuchstaben, Ziffer, Sonderzeichen. Sicher weitergeben.',
    updated: 'Benutzer aktualisiert',
    deleteTitle: 'Benutzer löschen?',
    deleteText:
      '{name} ({email}) wird überall abgemeldet und mit allen Sitzungen und Rollenzuweisungen endgültig entfernt. Erstellte Inhalte bleiben erhalten. Dies kann nicht rückgängig gemacht werden.',
    deleted: 'Benutzer gelöscht',
    disableTitle: 'Benutzer deaktivieren?',
    disableText:
      '{name} wird überall abgemeldet und kann sich erst nach der Reaktivierung wieder anmelden.',
    reenabled: 'Benutzer wieder aktiviert',
    unlock: 'Entsperren',
    lastSignIn: 'Letzte Anmeldung',
    resetPassword: 'Passwort zurücksetzen',
    newPassword: 'Neues Passwort',
    resetDone: 'Passwort zurückgesetzt; alle Sitzungen abgemeldet',
    twoFactor: 'Zwei-Faktor-Authentifizierung',
    twoFactorOn: 'An',
    twoFactorOff: 'Aus',
    resetTwoFactor: '2FA zurücksetzen',
    resetTwoFactorTitle: 'Zwei-Faktor-Authentifizierung zurücksetzen?',
    resetTwoFactorText:
      '{name} hat das Telefon und die Wiederherstellungscodes verloren? Bis 2FA wieder aktiviert wird, genügt das Passwort zur Anmeldung. Der Vorgang wird im Audit-Log festgehalten.',
    resetTwoFactorDone: 'Die Zwei-Faktor-Authentifizierung wurde zurückgesetzt',
    reset: 'Zurücksetzen',
    lead: 'Personen, die sich bei GX-CMS anmelden können. Zugriff wird über Rollen vergeben.',
    add: 'Benutzer hinzufügen',
    searchPlaceholder: 'Name oder E-Mail',
    anyStatus: 'Jeder Status',
    none: 'Keine Benutzer gefunden',
  },
  roles: {
    audit: 'Protokoll',
    newRole: 'Neue Rolle',
    lead: 'Rollen bündeln Berechtigungen. Jede API prüft Berechtigungen bei jeder Anfrage auf dem Server; Änderungen wirken innerhalb von Sekunden.',
    users: { one: '{count} Benutzer', other: '{count} Benutzer' },
    system: 'System',
    deleteTitle: 'Rolle löschen?',
    deleteText: '{count} Benutzer verlieren die Berechtigungen von „{name}“.',
    saved: 'Berechtigungen gespeichert',
    adminAll: 'Die Administratorrolle hat immer alle Berechtigungen.',
    created: 'Rolle erstellt — wählen Sie jetzt ihre Berechtigungen',
  },
  permissions: {
    'user.read': 'Benutzer und Rollen ansehen',
    'user.manage':
      'Benutzer erstellen, ändern und deaktivieren; Rollen verwalten',
    'user.delete': 'Benutzerkonten endgültig löschen',
    'content.type.read': 'Inhaltstypen und Felder ansehen',
    'content.type.manage': 'Inhaltstypen und Felder erstellen und ändern',
    'content.entry.read': 'Einträge, Entwürfe und Versionen ansehen',
    'content.entry.create': 'Einträge erstellen',
    'content.entry.update':
      'Entwürfe bearbeiten, zur Prüfung einreichen und Einträge archivieren',
    'content.entry.publish':
      'Einträge veröffentlichen, zurückziehen und planen',
    'content.entry.rollback': 'Einträge auf frühere Versionen zurücksetzen',
    'content.entry.delete': 'Jeden Eintrag endgültig löschen',
    'content.entry.delete.own': 'Selbst erstellte Einträge endgültig löschen',
    'content.type.delete': 'Inhaltstypen samt allen Einträgen löschen',
    'media.read': 'Mediathek ansehen',
    'media.upload': 'Medien hochladen und bearbeiten',
    'media.delete': 'Jedes Medium löschen',
    'media.delete.own': 'Selbst hochgeladene Medien löschen',
    'plugin.read': 'Plugins ansehen',
    'plugin.install':
      'Plugins finden, installieren und deinstallieren; Berechtigungen gewähren',
    'plugin.enable': 'Plugins aktivieren und deaktivieren',
    'plugin.configure': 'Plugins konfigurieren',
    'plugin.delete': 'Plugin-Einträge aus der Registry entfernen',
    'plugin.feature.manage': 'Feature-Flags von Plugins schalten',
    'audit.read': 'Das Protokoll durchsuchen',
    'mail.settings.manage':
      'Manage the e-mail (SMTP) settings of the CMS and plugins',
    'mail.send': 'Send e-mail through the CMS mail settings (plugins)',
    'backup.export':
      'Eine Sicherung aller Daten und Mediendateien herunterladen, einschließlich Benutzern und Einstellungen',
    'backup.import':
      'Alle Daten und Mediendateien durch eine Sicherung ersetzen',
    'site.settings.manage':
      'Name, Beschreibung, Sprachen und Kontaktdaten der Website bearbeiten',
  },
  audit: {
    lead: 'Ein unveränderliches Protokoll sicherheits- und geschäftsrelevanter Ereignisse aller Dienste.',
    action: 'Aktion',
    actionPlaceholder: 'z. B. content.entry.published',
    resource: 'Ressource',
    any: 'Beliebig',
    outcome: 'Ergebnis',
    from: 'Von',
    to: 'Bis',
    none: 'Keine Ereignisse',
    noneText: 'Nichts entspricht diesen Filtern.',
    time: 'Zeit',
    actor: 'Akteur',
    event: 'Protokollereignis',
    source: 'Quelle',
    correlation: 'Korrelation',
    eventId: 'Ereignis-ID',
    metadata: 'Metadaten',
  },
  mfa: {
    title: 'Bestätigung in zwei Schritten',
    help: 'Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App oder einen Ihrer Wiederherstellungscodes ein.',
    code: 'Code',
    verify: 'Bestätigen',
    back: 'Zurück zur Anmeldung',
    panel: 'Zwei-Faktor-Authentifizierung',
    off: 'Aus: Ihr Passwort allein genügt zur Anmeldung. Aktiviert wird zusätzlich ein Code aus einer Authenticator-App auf Ihrem Telefon verlangt.',
    on: 'Aktiv seit {date}. Verbleibende Wiederherstellungscodes: {count}.',
    turnOn: 'Aktivieren',
    scan: 'Scannen Sie den QR-Code mit einer Authenticator-App (zum Beispiel Google Authenticator, Microsoft Authenticator oder 1Password) oder geben Sie den Schlüssel ein. Geben Sie dann den angezeigten Code ein.',
    key: 'Schlüssel',
    appCode: 'Code aus der App',
    enabled: 'Die Zwei-Faktor-Authentifizierung ist aktiv',
    recoveryTitle: 'Ihre Wiederherstellungscodes',
    recoveryHelp:
      'Mit jedem Code können Sie sich einmal anmelden, falls Sie Ihr Telefon verlieren. Speichern Sie sie jetzt an einem sicheren Ort: Sie werden nicht erneut angezeigt.',
    copy: 'Codes kopieren',
    copied: 'Codes kopiert',
    saved: 'Gespeichert',
    codeHelp: 'Ein Code aus der App oder ein Wiederherstellungscode',
    turnOff: 'Deaktivieren',
    disabled: 'Die Zwei-Faktor-Authentifizierung ist deaktiviert',
    newCodes: 'Neue Wiederherstellungscodes',
    newCodesDone: 'Neue Wiederherstellungscodes; die alten gelten nicht mehr',
  },
  settings: {
    profileUpdated: 'Profil aktualisiert',
    mismatch: 'Die neuen Passwörter stimmen nicht überein.',
    passwordChanged: 'Passwort geändert. Andere Sitzungen wurden abgemeldet.',
    kicker: 'Ihr Konto',
    profile: 'Profil',
    emailHelp:
      'Bitten Sie eine Administratorin oder einen Administrator, Ihre E-Mail zu ändern.',
    saveProfile: 'Profil speichern',
    currentPassword: 'Aktuelles Passwort',
    passwordHelp:
      'Mindestens 12 Zeichen mit drei von: Kleinbuchstaben, Großbuchstaben, Ziffer, Sonderzeichen.',
    confirmPassword: 'Neues Passwort bestätigen',
    changePassword: 'Passwort ändern',
    appearance: 'Darstellung',
    design: 'Design',
    designHelp:
      'Ändert das Aussehen des Admins und der Plugin-Seiten für Sie in diesem Browser. Hell oder dunkel wählen Sie darunter.',
    designs: {
      gxlabs: {
        name: 'GXLabs (Standard)',
        about: 'Schwarz-weiß mit Cyan-Akzent',
      },
      apple: { name: 'Apple', about: 'Ruhig, abgerundet, im macOS-Stil' },
      aurora: { name: 'Aurora', about: 'Violett, Fuchsia und Cyan' },
      sunset: { name: 'Sunset', about: 'Koralle, Mandarine und Rosé' },
      lagoon: { name: 'Lagoon', about: 'Petrol, Smaragd und Himmelblau' },
      neon: {
        name: 'Neon',
        about: 'Magenta und Cyan, am schönsten im Dunkelmodus',
      },
    },
    theme: 'Design',
    light: 'Hell',
    dark: 'Dunkel',
    system: 'Wie System',
    languageHelp:
      'Die Verwaltung ist in den Sprachen der Website verfügbar. Plugin-Seiten, die Ihre Sprache nicht unterstützen, verwenden ihre Standardsprache.',
    access: 'Zugriff',
    permissions: 'Berechtigungen',
  },
  website: {
    kicker: 'Verwaltung',
    title: 'Website',
    lead: 'Was die öffentliche Website über sich zeigt: Name, Beschreibung, Sprachen und Kontaktdaten. Die CMS-Verwaltung verwendet diese Einstellungen nicht.',
    general: 'Allgemein',
    name: 'Name der Website',
    nameHelp: 'Im Browser-Tab, in Suchergebnissen und in der Fußzeile.',
    descriptionIn: 'Beschreibung ({language})',
    descriptionHelp:
      'Erscheint in Suchergebnissen und wenn eine Seite der Website geteilt wird.',
    languages: 'Sprachen',
    languagesLabel: 'Sprachen der Website',
    languagesHelp:
      'Die Website bietet nur diese an. Redakteure können weiterhin in jeder CMS-Sprache schreiben: Die Inhalte erscheinen auf der Website, sobald ihre Sprache hier eingeschaltet ist.',
    defaultLanguage: 'Standardsprache',
    defaultLanguageHelp:
      'Hier landen Besucher, die die Adresse ohne Sprache aufrufen.',
    contact: 'Kontakt',
    contactLead:
      'Im Kontaktbereich und in der Fußzeile jeder Seite. Leere Felder werden ausgeblendet.',
    email: 'E-Mail',
    phone: 'Telefon',
    address: 'Adresse',
    mapQuery: 'Karte',
    mapQueryHelp:
      'Google-Maps-Suchtext der Karte unten auf jeder Seite, z. B. Firmenname und Adresse. Leer = keine Karte.',
    social: 'Soziale Medien',
    fonts: 'Schriften',
    adobeFontsKit: 'Adobe-Fonts-Kit-ID',
    adobeFontsKitHelp:
      'Das Kit mit den Schriften der Website (die Domains der Website in Adobe Fonts erlauben). Leer = freie Ersatzschriften.',
    save: 'Speichern',
    saved:
      'Website-Einstellungen gespeichert. Die Website zeigt sie innerhalb einer Minute.',
    lastSaved: 'Zuletzt gespeichert {when}',
    neverSaved: 'Noch nicht gespeichert.',
  },
  backup: {
    kicker: 'Verwaltung',
    title: 'Datensicherung',
    lead: 'Laden Sie alles, was diese Website enthält, als eine ZIP-Datei herunter oder ersetzen Sie es durch eine solche Datei: als Sicherungskopie oder für den Umzug auf einen anderen Server.',
    exportTitle: 'Sicherung herunterladen',
    exportLead:
      'Die ZIP-Datei enthält die Daten des CMS (Inhalte, Benutzer und Rollen, Einstellungen, Plugins, CRM, Kontaktnachrichten, Audit-Protokoll) als SQL sowie alle Mediendateien. NEAREEs eigene Daten (Profile, Likes, Matches, Chats) sind noch nicht enthalten.',
    exportSecret:
      'Sie enthält personenbezogene Daten, Passwort-Hashes und verschlüsselte Geheimnisse. Bewahren Sie sie so sicher auf wie ein Passwort.',
    exportKeys:
      'Im Admin gespeicherte Geheimnisse (SMTP-Passwörter, Zahlungsschlüssel) sind mit den Serverschlüsseln PLUGIN_SECRETS_KEY und MAIL_SECRETS_KEY verschlüsselt. Lesbar bleiben sie nur dort, wo dieselben Schlüssel gesetzt sind.',
    download: 'Sicherung herunterladen',
    preparing: 'Wird vorbereitet…',
    downloadStarted:
      'Der Download hat begonnen. Bei großen Websites dauert er eine Weile.',
    importTitle: 'Sicherung importieren',
    importLead:
      'Laden Sie eine mit GX-CMS erstellte Sicherung hoch. Sie sehen ihren Inhalt, bevor sich etwas ändert.',
    importReplaces:
      'Ein Import ersetzt alle Daten und Mediendateien dieser Website. Benutzer, Passwörter und Rollen stammen danach aus der Sicherung; Sie melden sich anschließend mit einem Konto aus der Sicherung an.',
    chooseFile: 'ZIP-Datei auswählen',
    uploading: 'Wird hochgeladen… {percent} %',
    checking: 'Sicherung wird geprüft…',
    backupOf: 'Sicherung von {source}',
    unknownSource: 'unbekannter Website',
    createdAt: 'Erstellt am {date} mit GX-CMS {version}',
    part: 'Bereich',
    rows: 'Datensätze',
    mediaFiles: 'Mediendateien',
    mediaSummary: '{files} Dateien, {size}',
    canImport: 'Diese Sicherung kann importiert werden.',
    cannotImport: 'Diese Sicherung kann hier nicht importiert werden:',
    notes: 'Gut zu wissen:',
    replace: 'Alle Daten ersetzen…',
    discard: 'Upload verwerfen',
    discarded: 'Upload verworfen',
    confirmTitle: 'Alle Daten ersetzen?',
    confirmMessage:
      'Alle Inhalte, Benutzer, Einstellungen und Plugin-Daten dieser Website werden durch die Sicherung vom {date} ersetzt. Eine Kopie der aktuellen Daten wird bis zum Ende des Imports aufbewahrt und wiederhergestellt, falls der Import fehlschlägt. Geben Sie {word} ein, um fortzufahren.',
    confirmWord: 'ERSETZEN',
    confirmLabel: 'Alle Daten ersetzen',
    running: 'Wird importiert…',
    steps: {
      check: 'Prüfung',
      media: 'Mediendateien werden kopiert ({count})',
      'safety-copy': 'Kopie der aktuellen Daten wird angelegt',
      database: '{part} wird geladen',
      rollback:
        'Ein Fehler ist aufgetreten: Die bisherigen Daten werden wiederhergestellt',
      done: 'Fertig',
    } as Record<string, string>,
    succeeded:
      'Die Sicherung wurde importiert: {rows} Datensätze und {files} Mediendateien. Melden Sie sich mit einem Konto aus der Sicherung an.',
    signIn: 'Anmelden',
    failed: 'Der Import ist fehlgeschlagen: {error}',
    rolledBack:
      'Die bisherigen Daten wurden wiederhergestellt; außer neuen Mediendateien hat sich nichts geändert.',
    notRolledBack:
      'Die Daten sind möglicherweise unvollständig. Importieren Sie die Sicherung erneut oder eine andere.',
    statusLost:
      'Sie wurden während des Imports abgemeldet. Der Fortschritt wird unten angezeigt.',
    parts: {
      'identity-service': 'Benutzer, Rollen und E-Mail-Einstellungen',
      'content-service': 'Inhalte und Inhaltstypen',
      'media-service': 'Mediathek',
      'plugin-service': 'Plugins und ihre Einstellungen',
      'audit-service': 'Audit-Protokoll',
      'crm-service': 'CRM',
      'webshop-service': 'Webshop',
      'appointments-service': 'Terminbuchung',
      'contact-service': 'Kontaktnachrichten',
      'mobile-app-service': 'Mobile App',
    } as Record<string, string>,
    issues: {
      format_unsupported:
        'Sie wurde mit einer neueren GX-CMS-Version erstellt (Sicherungsformat {version}).',
      manifest_invalid:
        'Es ist keine GX-CMS-Sicherung, oder die Datei ist beschädigt.',
      file_missing: 'Ein Teil der Sicherung fehlt ({part}).',
      service_unavailable:
        '{part}: Dieser Bereich läuft auf dieser Website nicht. Schalten Sie ihn zuerst ein.',
      service_not_in_backup:
        '{part}: nicht in der Sicherung enthalten; die aktuellen Daten bleiben erhalten.',
      migrations_differ_older:
        '{part}: Die Sicherung stammt von einer älteren GX-CMS-Version. Importieren Sie sie in diese Version und aktualisieren Sie danach.',
      migrations_differ_newer:
        '{part}: Die Sicherung stammt von einer neueren GX-CMS-Version. Aktualisieren Sie zuerst diese Website.',
      migrations_differ_different:
        '{part}: Die Sicherung stammt von einer anderen GX-CMS-Version.',
      key_differs:
        '{part}: Dieser Server hat einen anderen {key}. Im Admin gespeicherte Geheimnisse (Passwörter, Zahlungsschlüssel) sind nach dem Import nicht lesbar; geben Sie sie neu ein oder setzen Sie vorher denselben Schlüssel.',
    } as Record<string, string>,
  },
  errors: {
    generic: 'Etwas ist schiefgelaufen.',
    offline: 'GX-CMS ist nicht erreichbar. Prüfen Sie Ihre Verbindung.',
    uploadFailed: 'Hochladen fehlgeschlagen',
    uploadNetwork: 'Hochladen fehlgeschlagen: Netzwerkfehler.',
  },
}
